export default {
  colors: {
    primary: '#0186C4',
    surface: '#0D214E',
    accent: '#0186C4',
    'accent-selection-background': '#D8E8F6',
    'accent-text': '#FFFFFF',
    'canvas-actions': '#0D214E',
    'canvas-background': '#F5F7FC',
    'canvas-edit-outline': '#017EB9',
    'canvas-outline': '#4C5C82',
    'navigation-background': '#0D214E',
    'panel-background-secondary': '#FFFFFF',
    'panel-background-tertiary': '#D8D8D8',
    'panel-background': '#F3F5FB',
    'panel-outline': '#E2E3E5',
    'text-canvas-primary': '#FFFFFF',
    'text-canvas-secondary': '#DBDEED',
    'text-navigation-primary': '#FFFFFF',
    'text-navigation-secondary': '#C6CBDC',
    'text-panel-primary': '#232529',
    'text-panel-secondary': '#57585A',
    'text-panel-tertiary': '#949494'
  }
}
